import { HousingCardSkeleton } from "@/components";
import { List } from "./styled";

const SKELETON_COUNT = 4;

export const WatchListSkeleton = () => (
  <List>
    {Array.from({ length: SKELETON_COUNT }).map((_, i) => (
      <HousingCardSkeleton key={i} />
    ))}
  </List>
);
